import { render, staticRenderFns } from "./year-levels.vue?vue&type=template&id=ff7b0982"
import script from "./year-levels.vue?vue&type=script&lang=js"
export * from "./year-levels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports